module.exports = __webpack_public_path__ + "img/align-left.8c350613.svg";